import React from 'react';
import { Helmet } from 'react-helmet-async';

const BlogSEO: React.FC = () => {
  const articleData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "How SentiHype Tracked Opendoor's Meme Stock Surge",
    "description": "In July 2025, Opendoor (ticker: $OPEN) became one of the most dramatic meme-stock stories of the year. SentiHype tracked the spike in Reddit activity around $OPEN.",
    "image": "https://sentihype.com/og-blog-opendoor.jpg",
    "author": {
      "@type": "Organization",
      "name": "SentiHype",
      "url": "https://sentihype.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "SentiHype",
      "logo": {
        "@type": "ImageObject",
        "url": "https://sentihype.com/logo.png"
      }
    },
    "datePublished": "2025-07-28T10:00:00Z",
    "dateModified": "2025-07-28T10:00:00Z",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://sentihype.com/blog/opendoor"
    },
    "keywords": [
      "SentiHype",
      "Opendoor",
      "OPEN stock",
      "meme stock",
      "Reddit sentiment",
      "stock analysis",
      "social sentiment",
      "market analytics",
      "social analytics",
      "stock surge",
      "retail investors",
      "social media trading"
    ],
    "articleSection": "Case Study",
    "inLanguage": "en-US"
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>How SentiHype Tracked Opendoor's Meme Stock Surge | SentiHype Blog</title>
      <meta name="description" content="In July 2025, Opendoor (ticker: $OPEN) became one of the most dramatic meme-stock stories of the year. SentiHype tracked the spike in Reddit activity around $OPEN with real-time social sentiment analytics." />
      <meta name="keywords" content="SentiHype, Opendoor, OPEN stock, meme stock, Reddit sentiment, stock analysis, social sentiment, market analytics, stock surge, retail investors, social media trading" />
      <meta name="author" content="SentiHype" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content="How SentiHype Tracked Opendoor's Meme Stock Surge" />
      <meta property="og:description" content="In July 2025, Opendoor (ticker: $OPEN) became one of the most dramatic meme-stock stories of the year. SentiHype tracked the spike in Reddit activity around $OPEN." />
      <meta property="og:url" content="https://sentihype.com/blog/opendoor" />
      <meta property="og:site_name" content="SentiHype" />
      <meta property="og:image" content="https://sentihype.com/og-blog-opendoor.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />
      <meta property="article:published_time" content="2025-07-28T10:00:00Z" />
      <meta property="article:modified_time" content="2025-07-28T10:00:00Z" />
      <meta property="article:section" content="Case Study" />
      <meta property="article:tag" content="SentiHype" />
      <meta property="article:tag" content="Opendoor" />
      <meta property="article:tag" content="OPEN stock" />
      <meta property="article:tag" content="meme stock" />
      <meta property="article:tag" content="Reddit sentiment" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="How SentiHype Tracked Opendoor's Meme Stock Surge" />
      <meta name="twitter:description" content="In July 2025, Opendoor (ticker: $OPEN) became one of the most dramatic meme-stock stories of the year. SentiHype tracked the spike in Reddit activity around $OPEN." />
      <meta name="twitter:image" content="https://sentihype.com/og-blog-opendoor.jpg" />
      <meta name="twitter:site" content="@sentihype" />
      <meta name="twitter:creator" content="@sentihype" />
      
      {/* Additional SEO Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#4ff6e6" />
      <meta name="msapplication-TileColor" content="#4ff6e6" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Canonical URL */}
      <link rel="canonical" href="https://sentihype.com/blog/opendoor" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(articleData)}
      </script>
      
      {/* Additional Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "SentiHype",
          "url": "https://sentihype.com",
          "logo": "https://sentihype.com/logo.png",
          "description": "Real-time Reddit sentiment analytics for stocks and crypto",
          "sameAs": [
            "https://twitter.com/sentihype",
            "https://t.me/sentihype"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "url": "https://sentihype.com/contact"
          }
        })}
      </script>
      
      {/* Breadcrumb Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://sentihype.com"
            },
                         {
               "@type": "ListItem",
               "position": 2,
               "name": "Blog",
               "item": "https://sentihype.com/blog"
             },
             {
               "@type": "ListItem",
               "position": 3,
               "name": "Opendoor Case Study",
               "item": "https://sentihype.com/blog/opendoor"
             }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default BlogSEO; 
